import Construct from 'can/construct/construct';
import can from 'can';
import FeedTransport from 'scripts/transports/feed-transport';
import { getValidCards } from 'scripts/models/api/cards/cards';
import urlUtil from 'scripts/utils/url';

const latestFeedUrl = window.globalSettings.feeds.timeline.latestFeedUrl;
const tagBasedLatestFeedUrl =
    window.globalSettings.feeds.timeline.tagBasedLatestFeedUrl;
const playerFeedUrl = window.globalSettings.feeds.timeline.playerFeedUrl;
const videoFeedUrl = window.globalSettings.feeds.videos.feedUrl;
const videoFiltersUrl = window.globalSettings.feeds.videos.filtersUrl;

export default Construct.extend({}, can.event).extend({
    loadLatest(type = 'all', page = 1, tags = null) {
        let url; // for local work use this url - 'http://localhost:8060/data/feeds/timeline.photos.1.USOpen_Video_highlights,USOpen_years_2020,USOpen_Video_2020_rounds_playoff,USOpen_players_47959.json';
        if (tags) {
            url = can.sub(tagBasedLatestFeedUrl, {
                filter: type,
                index: page,
                tags,
            });
        } else {
            url = can.sub(latestFeedUrl, {
                filter: type,
                index: page,
            });
        }
        return this.fetch(url);
    },

    loadPlayer(type, identifier, page) {
        const url = can.sub(playerFeedUrl, {
            filter: type,
            identifier: identifier,
            index: page,
        });
        return this.fetch(url);
    },

    loadVideoDetail(filter, tag1 = 'all', tag2 = 'all', page = 1) {
        const url = can.sub(videoFeedUrl, {
            filter,
            tag1,
            tag2,
            index: page,
        });
        return this.request(url);
    },

    loadVideoFilters(tag1 = 'all') {
        return FeedTransport.request(can.sub(videoFiltersUrl, { tag1 }, true));
    },

    fixPhotoCards(timelineFeed) {
        return timelineFeed.cards.map((card) => {
            if (card.type === 'photoCard') {
                const url = urlUtil.parseUrl(card.shareUrl);
                card.contentPath = url.pathname + url.search + url.hash;
            }
            return card;
        });
    },

    fetch: function(url) {
        this.dispatch('loading', [true]);
        return FeedTransport.request(url, true)
            .then((data) => {
                const fixedCards = this.fixPhotoCards(data);
                data.cards = fixedCards;
                return data;
            })
            .then((data) => {
                this.dispatch('data', [
                    getValidCards(data.cards),
                    data.total,
                    data.index,
                ]);
                this.dispatch('loading', [false]);
                return data;
            })
            .fail((error) => {
                this.dispatch('error', [error]);
            });
    },

    request(url) {
        return FeedTransport.request(url, true)
            .then((data) => {
                return [data.cards, data.total, data.index];
            })
            .fail((error) => {
                return can.Deferred().reject(error);
            });
    },
});
